import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getWalletTokens } from "../requests/getTransactions";
import { useParams } from "react-router-dom";

export const WalletUrlToken = ({ walletsUrl }) => {

  const [wallets, setWallets] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    (async () => {
      setWallets(await getWalletTokens(id));
    })();
  }, [id]);

  const { t } = useTranslation();

  return (wallets.length > 0 &&
    <div className="p-6 bg-gradient-to-r from-red-50 to-red-100 shadow-lg rounded-lg mx-auto mt-4">
      <h1 className="text-2xl font-bold text-blue-800 mt-4">{t('usdt_wallet')}:</h1>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {wallets.map((wallet, index) => (
          <div key={index} style={{ flex: '1 0 33%', boxSizing: 'border-box', padding: '10px' }}>
            <div style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}>
              <a className="hover:bg-gray-400" href={`https://usdt.tokenview.io/en/address/${wallet.cc_address}`} target="_blank" rel="noreferrer">{wallet.cc_address}</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
